import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, Link, useNavigate } from 'react-router-dom'
import { Layout, Menu, Image, Avatar, Col, Row, Badge, Popover, Dropdown, Typography, Space } from 'antd';
import axios from "axios";
import { MenuOutlined, MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, CommentOutlined, BellOutlined, DownOutlined } from '@ant-design/icons';
import ChatRoom from '../ChatRoom';

function CourseLayout(props) {
    const [user_name, set_user_name] = useState('');
    const [collapsed, setCollapsed] = useState(false);
    const { Header, Content, Sider } = Layout;
    const [title, setTitle] = useState();
    const [unread_count, set_unread_count] = useState(0);
    const [identity, setIdentity] = useState();
    const [examonline, setExamOnline] = useState('');
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem('user')
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const titles = {
        '/cramSchool/admin/CourseOutlineManage': '課綱維護',
        '/cramSchool/admin/MakeUpCourseManage': '補課管理',
        '/cramSchool/admin/CourseMaterial': '上課教材',
        '/cramSchool/admin/HomeWork': '回家作業',
        '/cramSchool/admin/Test': '隨堂測驗',
        '/cramSchool/admin/CourseStudentOverview': '學生總覽',
        '/cramSchool/admin/CourseStudentAttendance': '缺曠點名',
    }
    const link = (item) => {
        if (item.key != null && item.key != '/cramSchool/admin/manuals') {
            navigate(item.key);
            document.title = titles[item.key]
            setSelectedKeys([item.key])
        }
    }
    useEffect(() => {
        axios
            .get('/cramSchool/api/permission')
            .then(response => {
                set_user_name(prev => {
                    response.data.forEach(each_item => {
                        prev = each_item.user_name
                    });
                    return prev
                })
            })
    }, [])
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    useEffect(() => {
        setSelectedKeys([window.location.pathname])
        document.title = titles[window.location.pathname]
    }, [window.location.pathname])

    return (
        <>
            {/* <Layout> */}
            <Layout style={{
                backgroundColor: 'white'
            }}>
                {dimensions['width'] > 700 ?
                    <Sider
                        // breakpoint="lg" collapsedWidth="0" 
                        theme="light"
                        // collapsible
                        trigger={null}
                        collapsed={collapsed}
                    >
                        {/* {dimensions['width'] > 400 ? <> */}
                        <Menu
                            onSelect={link}
                            mode="inline"
                            defaultOpenKeys={['admin', 'before', 'basic']}
                            defaultSelectedKeys={['/cramSchool']}
                            selectedKeys={selecte_keys}
                            items={
                                props.li
                            }
                            style={{
                                whiteSpace: 'nowrap',
                                width: 'max-content',
                                backgroundColor: 'white',
                            }}
                        />
                        {/* </> : null} */}
                    </Sider> : null}
                <Layout style={{
                    backgroundColor: 'white',
                    marginLeft: '30px'
                }}>
                    <Header style={{ backgroundColor: 'white', paddingRight: '20px' }}>
                        <Row justify='space-between' align='top' gutter={16} >
                            <Col style={{ zIndex: 99 }}>
                                <Row gutter={16} align='middle' >
                                    {dimensions['width'] > 700 ?
                                        <>
                                            <Col>
                                                {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                                    className: 'trigger',
                                                    onClick: () => setCollapsed(!collapsed),
                                                })}
                                            </Col>
                                            {/* <Col md={{ span: 12 }} > <p style={{ color: 'black', fontSize: '1.5rem', whiteSpace: 'nowrap' }}>您好{user_name != '' && ('，' + user_name)}</p></Col> */}
                                        </> : null}
                                    <Col style={{ fontSize: '1.4rem', fontWeight: 500 }}>{titles[selecte_keys]}</Col>
                                </Row>
                            </Col>
                            {/* <Col >
                                <Row gutter={16}>
                                    <Col>
                                        <Avatar size="large" icon={<UserOutlined />} />
                                    </Col>
                                    <Col>
                                        <Dropdown
                                            placement="bottomLeft"
                                            menu={{
                                                items: [
                                                    {
                                                        key: '1',
                                                        label: <a onClick={() => {
                                                            localStorage.removeItem('access_token')
                                                            localStorage.removeItem('refresh_token')
                                                            axios
                                                                .post('/logout')
                                                            navigate('/Login')
                                                        }} >
                                                            登出</a>,
                                                    },
                                                ]
                                            }}
                                        >
                                            <Typography.Link style={{ color: "#000" }}>
                                                <Space>
                                                    <Space
                                                        style={{
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis', maxWidth: '100px'
                                                        }}
                                                    >
                                                        {user_name}
                                                    </Space>
                                                    <DownOutlined />
                                                </Space>
                                            </Typography.Link>
                                        </Dropdown>
                                    </Col>
                                    <Col>
                                        <Popover
                                            overlayStyle={{ zIndex: 99 }}
                                            content={(<>
                                                <ChatRoom />
                                            </>)} trigger="click"
                                        >
                                            <Badge count={unread_count} style={{ zIndex: '99' }}>
                                                <Avatar icon={<CommentOutlined />} />
                                            </Badge>
                                        </Popover>
                                    </Col>
                                    {dimensions['width'] <= 700 ?
                                        <Col >
                                            <MenuOutlined
                                                onClick={e => { setCollapsed(!collapsed) }}
                                                style={{
                                                    marginBottom: 16,
                                                    cursor: 'pointer'
                                                }} />
                                        </Col> : null}
                                    {dimensions['width'] > 700 ?
                                        <Col>
                                            <Badge count={1} style={{ zIndex: '99' }}>
                                                <Avatar icon={<BellOutlined />} />
                                            </Badge>
                                        </Col> : null}
                                </Row>
                            </Col> */}
                        </Row>
                    </Header>
                    <Content style={{
                        padding: 24,
                        marginLeft: '30px'
                    }}>
                        {collapsed && dimensions['width'] <= 700 && (<Menu
                            mode="inline"
                            defaultSelectedKeys={['/']}
                            selectedKeys={selecte_keys}
                            onClick={link}
                            items={props.li}
                            style={{
                                whiteSpace: 'nowrap',
                                width: '100%',
                                textAlign: 'center'
                            }}
                        />)}
                        <Outlet />
                    </Content>
                </Layout>
            </Layout >
            {/* </Layout> */}
        </>
    )
}
export default CourseLayout;